import { useEffect } from 'react';
import { SignInPrompt } from '../../components/auth/SignInPrompt';
import { LoadingScreen } from '../../components/skeletons/LoadingScreen';
import { useAuth, useIsAuthenticated } from './AuthProvider';
import { getAuthGuardView, useRouteAuth } from './use-route-auth';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { requiresAuth } = useRouteAuth();
  const { isInProgress, silentAuthAttempted } = useAuth();
  const isAuthenticated = useIsAuthenticated();
  const view = getAuthGuardView({
    requiresAuth,
    isAuthenticated,
    silentAuthAttempted,
    isInProgress,
  });

  // Log the initial auth state for the route
  useEffect(() => {
    console.debug('[AUTH_GUARD] Route access check:', {
      path: window.location.pathname,
      requiresAuth,
      isAuthenticated,
      isInProgress,
      silentAuthAttempted,
      view,
      timestamp: new Date().toISOString(),
    });
  }, [requiresAuth, isAuthenticated, isInProgress, silentAuthAttempted, view]);

  if (view === 'loading') {
    return <LoadingScreen />;
  }

  if (view === 'sign-in') {
    return (
      <div className="flex items-center justify-center px-4 py-16">
        <SignInPrompt />
      </div>
    );
  }

  return <>{children}</>;
}
